import { isBrowser } from '@bombas/react/util';
import Cookies from 'js-cookie';
/**
 * (Browser only) Retrieves the BOM-COUNTRY cookie and parses it into its usable values.
 */
export var getBomCountryCookie = function () {
    if (!isBrowser())
        throw new Error('getBomCountryCookie is only supported in the browser.');
    var bomCountryCookie = Cookies.get('BOM-COUNTRY');
    /** Temporary added a default return for bomCountryCookie to prevent error,
     * but we should enforce the error to be thrown if the cookie is not found.
     */
    /**
    *   if (!bomCountryCookie)
      throw new Error('getBomCountryCookie missing BOM-COUNTRY cookie.');
    */
    if (!bomCountryCookie)
        return { country: '', isConfirmed: false };
    var _a = bomCountryCookie.split(':'), country = _a[0], isConfirmed = _a[1];
    return {
        country: country,
        isConfirmed: isConfirmed === '1'
    };
};
export default {};
